module.exports = __webpack_public_path__ + "static/media/toss_logo.05456acc.png";